import React from 'react';
import Spinner from '@atoms/Spinner/Spinner';

function RouteLoadingFallback() {
	return <Spinner center />;
}

export default React.memo(RouteLoadingFallback);
